import * as Types from '../../types.generated';

import { api } from '../../rootApi';
export type AuthGoogleMutationVariables = Types.Exact<{
  googleServerAuthCode: Types.Scalars['String'];
}>;

export type AuthGoogleMutation = {
  __typename?: 'Mutation';
  authGoogle: { __typename?: 'ApiKey'; accessToken: string };
};

export type AuthAppleMutationVariables = Types.Exact<{
  appleIdToken: Types.Scalars['String'];
  fullName?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type AuthAppleMutation = {
  __typename?: 'Mutation';
  authApple: { __typename?: 'ApiKey'; accessToken: string };
};

export type AuthLoginMutationVariables = Types.Exact<{
  auth: Types.Login;
}>;

export type AuthLoginMutation = {
  __typename?: 'Mutation';
  authLogin: { __typename?: 'ApiKey'; accessToken: string };
};

export type AuthIntrospectQueryVariables = Types.Exact<{
  auth: Types.Login;
}>;

export type AuthIntrospectQuery = {
  __typename?: 'Query';
  authIntrospect?:
    | {
        __typename?: 'ApiKey';
        accessToken: string;
        deviceName?: string | null | undefined;
        deviceType?: string | null | undefined;
        location?: string | null | undefined;
      }
    | null
    | undefined;
};

export type AuthSignUpMutationVariables = Types.Exact<{
  auth: Types.SignUp;
}>;

export type AuthSignUpMutation = {
  __typename?: 'Mutation';
  authSignUp: { __typename?: 'ApiKey'; accessToken: string };
};

export type AuthLogoutMutationVariables = Types.Exact<{ [key: string]: never }>;

export type AuthLogoutMutation = {
  __typename?: 'Mutation';
  authLogout: boolean;
};

export type AppleWebLoginQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AppleWebLoginQuery = {
  __typename?: 'Query';
  appleWebLogin: string;
};

export type UserCurrentQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserCurrentQuery = {
  __typename?: 'Query';
  userCurrent: {
    __typename?: 'CurrentUser';
    id: number;
    firstName: string;
    confirmedAt?: any | null | undefined;
    lastName?: string | null | undefined;
    email: string;
    phoneNumber?: string | null | undefined;
    gender?: Types.Gender | null | undefined;
    playbackPreference?:
      | {
          __typename?: 'PlaybackPreferencesObject';
          continueInPrahar: boolean;
          quality?: Types.PlaybackQuality | null | undefined;
          voiceType?: Types.Voice | null | undefined;
          artistType?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
          language?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    successfulTransactions?:
      | Array<{
          __typename?: 'Transaction';
          rzpOrderId?: string | null | undefined;
          amountCents: number;
          rzpSubscriptionId?: string | null | undefined;
          createdAt: any;
          subscription?:
            | {
                __typename?: 'Subscription';
                subscriptionPlan: {
                  __typename?: 'Plan';
                  price: number;
                  currencySymbol?: string | null | undefined;
                  name: string;
                };
              }
            | null
            | undefined;
        }>
      | null
      | undefined;
    activeSubscription?:
      | {
          __typename?: 'Subscription';
          id: number;
          renewalPolicy?: Types.SubscriptionRenewalPolicy | null | undefined;
          expiresAt: any;
          createdAt: any;
          isActive: boolean;
          subscriptionPlan: {
            __typename?: 'Plan';
            rzpPlanId?: string | null | undefined;
            id: number;
            name: string;
            paymentType: Types.Payment;
            price: number;
            currencySymbol?: string | null | undefined;
          };
        }
      | null
      | undefined;
    profilePicture?:
      | { __typename?: 'Attachment'; url: string; id: number }
      | null
      | undefined;
  };
};

export type GetFavouritesQueryVariables = Types.Exact<{
  perPage: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
}>;

export type GetFavouritesQuery = {
  __typename?: 'Query';
  userCurrent: {
    __typename?: 'CurrentUser';
    favourites?:
      | {
          __typename?: 'FavouritesList';
          totalDuration?: number | null | undefined;
          data?:
            | Array<{
                __typename?: 'Base';
                id: number;
                position: number;
                song?:
                  | {
                      __typename?: 'BaseSongType';
                      id: number;
                      lyrics?: string | null | undefined;
                      isFavourited: boolean;
                      trackLength: number;
                      title: string;
                      archive?:
                        | {
                            __typename?: 'Archive';
                            id: number;
                            displayLogo: boolean;
                            name: string;
                            profilePicture?:
                              | {
                                  __typename?: 'Attachment';
                                  filename: string;
                                  url: string;
                                }
                              | null
                              | undefined;
                          }
                        | null
                        | undefined;
                      lowQuality?:
                        | { __typename?: 'Attachment'; url: string; id: number }
                        | null
                        | undefined;
                      mediumQuality?:
                        | { __typename?: 'Attachment'; url: string; id: number }
                        | null
                        | undefined;
                      highQuality?:
                        | { __typename?: 'Attachment'; url: string; id: number }
                        | null
                        | undefined;
                      artists: {
                        __typename?: 'ArtistsConnection';
                        edges?:
                          | Array<
                              | {
                                  __typename?: 'ArtistsEdge';
                                  node?:
                                    | {
                                        __typename?: 'Artist';
                                        id: number;
                                        firstName: string;
                                        lastName?: string | null | undefined;
                                        bio?: string | null | undefined;
                                        profilePicture?:
                                          | {
                                              __typename?: 'Attachment';
                                              filename: string;
                                              url: string;
                                            }
                                          | null
                                          | undefined;
                                        musicInstrument?:
                                          | {
                                              __typename?: 'MusicalInstrument';
                                              id: number;
                                              name: string;
                                              profilePicture?:
                                                | {
                                                    __typename?: 'Attachment';
                                                    filename: string;
                                                    url: string;
                                                  }
                                                | null
                                                | undefined;
                                            }
                                          | null
                                          | undefined;
                                      }
                                    | null
                                    | undefined;
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined;
                      };
                      raga: {
                        __typename?: 'Raga';
                        id: number;
                        title: string;
                        notes?: string | null | undefined;
                        timeSections?:
                          | Array<{
                              __typename?: 'TimeSection';
                              name: string;
                              gradientTopColour: string;
                              gradientBottomColour: string;
                            }>
                          | null
                          | undefined;
                        samvadiSwar?:
                          | {
                              __typename?: 'Constant';
                              id: number;
                              name: string;
                            }
                          | null
                          | undefined;
                        pakadSwars?:
                          | Array<{
                              __typename?: 'RagaSwar';
                              position: number;
                              swar: {
                                __typename?: 'Constant';
                                id: number;
                                name: string;
                              };
                            }>
                          | null
                          | undefined;
                        jaati?:
                          | {
                              __typename?: 'Constant';
                              id: number;
                              name: string;
                            }
                          | null
                          | undefined;
                        thaat?:
                          | {
                              __typename?: 'Constant';
                              id: number;
                              name: string;
                            }
                          | null
                          | undefined;
                        aarohaSwars?:
                          | Array<{
                              __typename?: 'RagaSwar';
                              position: number;
                              swar: { __typename?: 'Constant'; name: string };
                            }>
                          | null
                          | undefined;
                        vaadiSwar?:
                          | {
                              __typename?: 'Constant';
                              id: number;
                              name: string;
                            }
                          | null
                          | undefined;
                      };
                    }
                  | null
                  | undefined;
              }>
            | null
            | undefined;
          paging: {
            __typename?: 'Paging';
            currentPage: number;
            totalItems: number;
            totalPages: number;
          };
        }
      | null
      | undefined;
  };
};

export type AuthResetPasswordMutationVariables = Types.Exact<{
  auth: Types.ResetPassword;
}>;

export type AuthResetPasswordMutation = {
  __typename?: 'Mutation';
  authResetPassword: { __typename?: 'ApiKey'; accessToken: string };
};

export type ForgetPasswordMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
}>;

export type ForgetPasswordMutation = {
  __typename?: 'Mutation';
  authForgotPassword: boolean;
};

export type AuthConfirmEmailMutationVariables = Types.Exact<{
  confirmationToken: Types.Scalars['String'];
}>;

export type AuthConfirmEmailMutation = {
  __typename?: 'Mutation';
  authConfrmEmail: { __typename?: 'ApiKey'; accessToken: string };
};

export const AuthGoogleDocument = `
    mutation authGoogle($googleServerAuthCode: String!) {
  authGoogle(googleServerAuthCode: $googleServerAuthCode) {
    accessToken
  }
}
    `;
export const AuthAppleDocument = `
    mutation authApple($appleIdToken: String!, $fullName: String) {
  authApple(appleIdToken: $appleIdToken, fullName: $fullName) {
    accessToken
  }
}
    `;
export const AuthLoginDocument = `
    mutation authLogin($auth: Login!) {
  authLogin(auth: $auth) {
    accessToken
  }
}
    `;
export const AuthIntrospectDocument = `
    query authIntrospect($auth: Login!) {
  authIntrospect(auth: $auth) {
    accessToken
    deviceName
    deviceType
    location
  }
}
    `;
export const AuthSignUpDocument = `
    mutation authSignUp($auth: SignUp!) {
  authSignUp(auth: $auth) {
    accessToken
  }
}
    `;
export const AuthLogoutDocument = `
    mutation authLogout {
  authLogout
}
    `;
export const AppleWebLoginDocument = `
    query appleWebLogin {
  appleWebLogin
}
    `;
export const UserCurrentDocument = `
    query userCurrent {
  userCurrent {
    id
    firstName
    confirmedAt
    lastName
    email
    phoneNumber
    gender
    playbackPreference {
      continueInPrahar
      artistType {
        id
        name
      }
      language {
        id
        name
      }
      quality
      voiceType
    }
    successfulTransactions {
      rzpOrderId
      amountCents
      rzpSubscriptionId
      createdAt
      subscription {
        subscriptionPlan {
          price
          currencySymbol
          name
        }
      }
    }
    activeSubscription {
      id
      renewalPolicy
      expiresAt
      createdAt
      isActive
      subscriptionPlan {
        rzpPlanId
        id
        name
        paymentType
        price
        currencySymbol
      }
    }
    profilePicture {
      url
      id
    }
  }
}
    `;
export const GetFavouritesDocument = `
    query getFavourites($perPage: Int!, $page: Int!) {
  userCurrent {
    favourites(perPage: $perPage, page: $page) {
      data {
        id
        position
        song {
          id
          archive {
            id
            displayLogo
            name
            profilePicture {
              filename
              url
            }
          }
          lyrics
          isFavourited
          lowQuality {
            url
            id
          }
          mediumQuality {
            url
            id
          }
          highQuality {
            url
            id
          }
          trackLength
          artists {
            edges {
              node {
                id
                firstName
                lastName
                bio
                profilePicture {
                  filename
                  url
                }
                musicInstrument {
                  id
                  name
                  profilePicture {
                    filename
                    url
                  }
                }
              }
            }
          }
          title
          raga {
            id
            title
            timeSections {
              name
              gradientTopColour
              gradientBottomColour
            }
            samvadiSwar {
              id
              name
            }
            pakadSwars {
              swar {
                id
                name
              }
              position
            }
            jaati {
              id
              name
            }
            thaat {
              id
              name
            }
            notes
            aarohaSwars {
              swar {
                name
              }
              position
            }
            vaadiSwar {
              id
              name
            }
          }
        }
      }
      paging {
        currentPage
        totalItems
        totalPages
      }
      totalDuration
    }
  }
}
    `;
export const AuthResetPasswordDocument = `
    mutation authResetPassword($auth: ResetPassword!) {
  authResetPassword(auth: $auth) {
    accessToken
  }
}
    `;
export const ForgetPasswordDocument = `
    mutation forgetPassword($email: String!) {
  authForgotPassword(email: $email)
}
    `;
export const AuthConfirmEmailDocument = `
    mutation authConfirmEmail($confirmationToken: String!) {
  authConfrmEmail(confirmationToken: $confirmationToken) {
    accessToken
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authGoogle: build.mutation<AuthGoogleMutation, AuthGoogleMutationVariables>(
      {
        query: (variables) => ({ document: AuthGoogleDocument, variables }),
      }
    ),
    authApple: build.mutation<AuthAppleMutation, AuthAppleMutationVariables>({
      query: (variables) => ({ document: AuthAppleDocument, variables }),
    }),
    authLogin: build.mutation<AuthLoginMutation, AuthLoginMutationVariables>({
      query: (variables) => ({ document: AuthLoginDocument, variables }),
    }),
    authIntrospect: build.query<
      AuthIntrospectQuery,
      AuthIntrospectQueryVariables
    >({
      query: (variables) => ({ document: AuthIntrospectDocument, variables }),
    }),
    authSignUp: build.mutation<AuthSignUpMutation, AuthSignUpMutationVariables>(
      {
        query: (variables) => ({ document: AuthSignUpDocument, variables }),
      }
    ),
    authLogout: build.mutation<
      AuthLogoutMutation,
      AuthLogoutMutationVariables | void
    >({
      query: (variables) => ({ document: AuthLogoutDocument, variables }),
    }),
    appleWebLogin: build.query<
      AppleWebLoginQuery,
      AppleWebLoginQueryVariables | void
    >({
      query: (variables) => ({ document: AppleWebLoginDocument, variables }),
    }),
    userCurrent: build.query<
      UserCurrentQuery,
      UserCurrentQueryVariables | void
    >({
      query: (variables) => ({ document: UserCurrentDocument, variables }),
    }),
    getFavourites: build.query<GetFavouritesQuery, GetFavouritesQueryVariables>(
      {
        query: (variables) => ({ document: GetFavouritesDocument, variables }),
      }
    ),
    authResetPassword: build.mutation<
      AuthResetPasswordMutation,
      AuthResetPasswordMutationVariables
    >({
      query: (variables) => ({
        document: AuthResetPasswordDocument,
        variables,
      }),
    }),
    forgetPassword: build.mutation<
      ForgetPasswordMutation,
      ForgetPasswordMutationVariables
    >({
      query: (variables) => ({ document: ForgetPasswordDocument, variables }),
    }),
    authConfirmEmail: build.mutation<
      AuthConfirmEmailMutation,
      AuthConfirmEmailMutationVariables
    >({
      query: (variables) => ({ document: AuthConfirmEmailDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useAuthGoogleMutation,
  useAuthAppleMutation,
  useAuthLoginMutation,
  useAuthIntrospectQuery,
  useLazyAuthIntrospectQuery,
  useAuthSignUpMutation,
  useAuthLogoutMutation,
  useAppleWebLoginQuery,
  useLazyAppleWebLoginQuery,
  useUserCurrentQuery,
  useLazyUserCurrentQuery,
  useGetFavouritesQuery,
  useLazyGetFavouritesQuery,
  useAuthResetPasswordMutation,
  useForgetPasswordMutation,
  useAuthConfirmEmailMutation,
} = injectedRtkApi;
